export interface OrderAttributes {
  gasDoPovo?: boolean;
}

export interface OrderProps {
  scheduling?: Scheduling;
  id: string;
  createdAt: string;
  consumer: {
    id: string;
    name: string;
    phone: string;
  };
  placedOrigin: string;
  dealer: {
    id: string;
    name: string;
  };
  driver: {
    id: string;
    name: string;
    surname?: string;
  };
  paymentStatus?: string;
  coverageArea: {
    id: string;
    name: string;
    areaType?: string;
    timeZone?: string;
  };
  delivery: {
    address: {
      number: string;
      street: string;
      complement: string;
      district: string;
      city: string;
      state: string;
      country: string;
      latitude: number;
      longitude: number;
    };
    remarks: string;
    eta: {
      initial: number;
      current: number;
    };
  };
  items: Items[];
  discount: 0;
  payment: {
    type: string;
    description: string;
    paymentMethodId: string;
    change: number;
  };
  fiscal: {
    document: string;
  };
  pin: string;
  status: string;
  consumerState: string;
  dealerState: string;
  voucher?: {
    code?: string;
    deviceId?: string;
    id?: string;
    campaign?: string;
    discount?: number;
    discountLimit?: number;
    percent?: number;
    valeGas?: boolean;
    validUntil?: string;
  };

  timeline: [
    {
      description: string;
      occurredAt: string;
    },
    {
      description: string;
      occurredAt: string;
    },
    {
      description: string;
      occurredAt: string;
    },
    {
      description: string;
      occurredAt: string;
    },
  ];
  approvals: [
    {
      approver: string;
      approved: boolean;
    },
    {
      approver: string;
      approved: boolean;
    },
  ];
}

export enum OrderUpdateActionsEnum {
  ACCEPT = "accept",
  START = "start",
  DENY = "deny",
  CANCEL = "cancel",
  FINALIZE = "finalize",
}

export enum DealerOrderState {
  NEW = "New",
  IN_PROGRESS = "InProgress",
  FINALIZED = "Finalized",
}

export type OrderUpdateActions = `${OrderUpdateActionsEnum}`;

export interface OrdersInitialStore {
  allOrders: never[] | OrderProps[] | any;
}

export interface OrdersResponse {
  newOrders: never[];
  inProgressOrders: never[];
  finalizedOrders: never[];
}

export interface Items {
  name?: string;
  description?: string;
  productId?: string;
  quantity?: number;
  unitPrice?: number;
  attributes?: OrderAttributes;
}

export type OrderUpdateActionsBody = { reason: string } | unknown;

export interface OrderUpdateRequest {
  dealerId: string;
  type: OrderUpdateActions;
  orderId: string;
  consumerId: string;
  platform: string;
  eta?: number | null;
  body?: OrderUpdateActionsBody;
  reasonNotProvidePin?: string;
  pin?: string;
}

export interface OrderAddDriveRequest {
  dealerId: string;
  orderId: string;
  clearDriver?: boolean;
  driverName?: string;
  driverId?: string;
}

export interface Scheduling {
  enabled: boolean;
  startAt: string | Date | null;
}
